import styled from 'styled-components';
import Moment from 'react-moment';
import { COLOR } from '../../../styles/variables';

export const DateLayout = styled(Moment)`
    color: ${COLOR.br24.lightMediumGrey};
    font-size: 0.85rem;
    line-height: 1.36;
    margin: 0 0 0.5rem;
`;
